{
  "name": "@bman654/clodex",
  "version": "2.15.0",
  "publishConfig": {
    "access": "public"
  },
  "description": "Bridge Claude Code to OpenAI and OpenCode Go models — API keys or ChatGPT/Codex-plan OAuth, with prompt caching, auto-compaction, model switching, and a Claude Code binary patcher",
  "author": "Brandon Wallace",
  "license": "MIT",
  "keywords": [
    "claude",
    "claude-code",
    "openai",
    "opencode",
    "chatgpt",
    "codex",
    "ai",
    "llm",
    "cli",
    "bridge",
    "proxy"
  ],
  "type": "module",
  "packageManager": "pnpm@10.34.5",
  "bin": {
    "clodex": "dist/cli.js",
    "clodex-claude": "dist/claude-wrapper.js"
  },
  "files": [
    "dist",
    "docs",
    "launcher",
    "README.md"
  ],
  "engines": {
    "node": ">=22"
  },
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "test": "vitest run",
    "test:watch": "vitest",
    "typecheck": "tsc --noEmit",
    "prepare": "husky",
    "prepublishOnly": "pnpm build",
    "update:opencode-go": "node scripts/update-opencode-go-models.mjs"
  },
  "dependencies": {
    "@ai-sdk/anthropic": "4.0.12",
    "@ai-sdk/openai": "4.0.11",
    "@ai-sdk/openai-compatible": "3.0.7",
    "@ai-sdk/provider-utils": "5.0.7",
    "@clack/prompts": "0.9.1",
    "ai": "7.0.22",
    "https-proxy-agent": "9.1.0",
    "ipaddr.js": "2.4.0",
    "node-forge": "1.4.0",
    "node-gyp-build": "4.8.4",
    "open": "11.0.0",
    "picocolors": "1.1.1",
    "tweakcc": "4.3.0",
    "undici": "7.29.0",
    "ws": "8.21.0"
  },
  "devDependencies": {
    "@commitlint/cli": "19.8.1",
    "@commitlint/config-conventional": "19.8.1",
    "@types/node": "22.19.19",
    "@types/node-forge": "1.3.14",
    "@types/ws": "8.18.1",
    "husky": "9.1.7",
    "tsup": "8.5.1",
    "typescript": "5.9.3",
    "vitest": "2.1.9"
  },
  "optionalDependencies": {
    "@napi-rs/keyring": "1.3.0"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/bman654/clodex.git"
  },
  "homepage": "https://github.com/bman654/clodex#readme",
  "bugs": {
    "url": "https://github.com/bman654/clodex/issues"
  }
}
